var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('table', {
    staticClass: "table table-sm border"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('th', {
    staticClass: "w-50 pr-3"
  }, [_vm._v("Port Of Loading")]), _c('th', {
    staticClass: "w-50 px-3"
  }, [_vm._v("Port Of Discharge")]), !_vm.isDetail ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "min-width": "40px"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus cursor-pointer",
    on: {
      "click": _vm.addPort
    }
  })]) : _vm._e()]), _c('tbody', _vm._l(_vm.form.ports, function (port, index) {
    var _vm$polOptions$find, _vm$podOptions$find;
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "w-50 pr-3 py-2 align-top"
    }, [!_vm.isDetail ? [_c('b-form-select', {
      attrs: {
        "options": _vm.polOptions,
        "plain": ""
      },
      model: {
        value: port.pol,
        callback: function callback($$v) {
          _vm.$set(port, "pol", $$v);
        },
        expression: "port.pol"
      }
    }), port.pol == 'other' ? _c('b-form-input', {
      staticClass: "mt-2",
      attrs: {
        "plain": ""
      },
      model: {
        value: port.polOther,
        callback: function callback($$v) {
          _vm.$set(port, "polOther", $$v);
        },
        expression: "port.polOther"
      }
    }) : _vm._e()] : [_c('p', {
      staticClass: "form-control-plaintext mb-0"
    }, [_vm._v(" " + _vm._s(port.pol === 'other' ? port.polOther || '-' : ((_vm$polOptions$find = _vm.polOptions.find(function (opt) {
      return opt.value === port.pol;
    })) === null || _vm$polOptions$find === void 0 ? void 0 : _vm$polOptions$find.text) || port.pol || '-') + " ")])]], 2), _c('td', {
      staticClass: "w-50 pl-3 py-2 align-top"
    }, [!_vm.isDetail ? [_c('b-form-select', {
      attrs: {
        "options": _vm.podOptions,
        "plain": ""
      },
      model: {
        value: port.pod,
        callback: function callback($$v) {
          _vm.$set(port, "pod", $$v);
        },
        expression: "port.pod"
      }
    }), port.pod == 'other' ? _c('b-form-input', {
      staticClass: "mt-2",
      attrs: {
        "plain": ""
      },
      model: {
        value: port.podOther,
        callback: function callback($$v) {
          _vm.$set(port, "podOther", $$v);
        },
        expression: "port.podOther"
      }
    }) : _vm._e()] : [_c('p', {
      staticClass: "form-control-plaintext mb-0"
    }, [_vm._v(" " + _vm._s(port.pod === 'other' ? port.podOther || '-' : ((_vm$podOptions$find = _vm.podOptions.find(function (opt) {
      return opt.value === port.pod;
    })) === null || _vm$podOptions$find === void 0 ? void 0 : _vm$podOptions$find.text) || port.pod || '-') + " ")])]], 2), !_vm.isDetail ? _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fas fa-trash-alt text-danger cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.handleDeletePort(index);
        }
      }
    })]) : _vm._e()]);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }